import { useEffect, useState } from 'react';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { HR } from 'foundations-components/transitional/components/HR';
import { View } from 'foundations-components/components/View';
import TaskViewCardHeader from './TaskViewCardHeader';
import ShowCompletedGroupsAccordion from './ShowCompletedGroupsAccordion';
import TaskGroup from './TaskGroup';
import CompletedTaskView from './CompletedTaskView';
import { useTaskGroupProgress, useTaskDataByGroupKey } from '../../../hooks/task';
import { useTaskGroupConfigOverrides } from '../../../hooks/viewConfig';
import { useTracker } from '../../../hooks/tracking';
import { useIsTaskCardDismissed } from '../../../contexts/TaskCardsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskViewCard = ({
  onboardingKey,
  onTaskGroupClick,
  viewGroupKey
}) => {
  const taskView = useTaskDataByGroupKey(viewGroupKey);
  const {
    completion: maybeCompletion
  } = useTaskGroupConfigOverrides(onboardingKey, viewGroupKey);
  const [showCompletedGroups, setShowCompletedGroups] = useState(false);
  const {
    completedTaskGroups: completedChildGroups,
    uncompletedTaskGroups: uncompletedChildGroups
  } = useTaskGroupProgress(taskView);
  const showCompletedGroupsToggle = completedChildGroups.length > 0;
  const isDismissed = useIsTaskCardDismissed(viewGroupKey);
  const {
    trackSectionView
  } = useTracker();
  useEffect(() => trackSectionView(isDismissed ? 'dismissed task view card' : 'task view card', viewGroupKey), [trackSectionView, viewGroupKey, isDismissed]);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-card-locator": viewGroupKey,
    children: [/*#__PURE__*/_jsx(TaskViewCardHeader, {
      onGroupClick: onTaskGroupClick,
      onboardingKey: onboardingKey,
      viewGroupKey: viewGroupKey
    }), /*#__PURE__*/_jsxs(CardSection, {
      paddingBlockEnd: showCompletedGroupsToggle ? '600' : undefined,
      children: [uncompletedChildGroups.length === 0 && /*#__PURE__*/_jsx(CompletedTaskView, {
        groupKey: viewGroupKey,
        viewConfig: maybeCompletion
      }), uncompletedChildGroups.map((taskGroup, index) => /*#__PURE__*/_jsx(TaskGroup, {
        groupKey: taskGroup.key,
        isLastGroup: index === uncompletedChildGroups.length - 1,
        isTaskGroupCompleted: false,
        onGroupClick: onTaskGroupClick
      }, taskGroup.key)), /*#__PURE__*/_jsxs(AccordionTransition, {
        open: showCompletedGroups && showCompletedGroupsToggle,
        children: [/*#__PURE__*/_jsx(View, {
          marginBlock: "500",
          paddingInlineStart: "1000",
          children: /*#__PURE__*/_jsx(HR, {
            color: "border-core-subtle",
            margin: "0"
          })
        }), completedChildGroups.map((taskGroup, index) => /*#__PURE__*/_jsx(TaskGroup, {
          groupKey: taskGroup.key,
          isLastGroup: index === completedChildGroups.length - 1,
          isTaskGroupCompleted: true,
          onGroupClick: onTaskGroupClick
        }, taskGroup.key))]
      }), showCompletedGroupsToggle && /*#__PURE__*/_jsx(ShowCompletedGroupsAccordion, {
        numberOfCompletedChildGroups: completedChildGroups.length,
        onClick: () => setShowCompletedGroups(previousValue => !previousValue),
        showCompletedGroups: showCompletedGroups
      })]
    })]
  });
};
export default TaskViewCard;